<template> 
<DesignNavBar />
  <main>
    <DesignPresentation />
      <div class="accordion-item-container">
        <DesignAboutMe ref="aboutMeSection" />
        <DesignCV ref="cvSection" /> 
        <DesignPortfolio ref="portfolioSection" />
        <DesignContact ref="contactSection" />
      </div>
  </main>
  <DesignFooter />
</template>

<script>
import DesignNavBar from './DesignGenerals/DesignNavBar.vue';
import DesignPresentation from './DesignPresentation/DesignPresentation.vue';
import DesignAboutMe from './DesignAboutMe/DesignAboutMe.vue';
import DesignCV from './DesignCV/DesignCV.vue'; 
import DesignPortfolio from './DesignPortfolio/DesignPortfolio.vue';
import DesignContact from './DesignContact/DesignContact.vue';
import DesignFooter from './DesignGenerals/DesignFooter.vue';

export default {
  name: 'DesignPage',
  components: {
    DesignNavBar,
    DesignPresentation,
    DesignAboutMe,
    DesignCV, 
    DesignPortfolio,
    DesignContact,
    DesignFooter,
  },
  provide() {
    return {
      openAccordionSection: this.openAccordionSection
    }
  },
  methods: {
    openAccordionSection(sectionId) {
        console.log('DesignPage recibió solicitud para abrir:', sectionId);
        
        const sectionMap = {
            'about-me': 'aboutMeSection',
            'curriculum-vitae': 'cvSection', 
            'portfolio': 'portfolioSection',
            'contact': 'contactSection'
        };
        
        const sectionRef = sectionMap[sectionId];
        if (sectionRef && this.$refs[sectionRef]) {
            console.log('Sección encontrada en refs:', sectionRef);
            this.simulateAccordionClick(sectionId);
        } else {
            console.log('Sección NO encontrada en refs');
        }
    },

    simulateAccordionClick(sectionId) {
        const bsTargetMap = {
            'about-me': 'collapseAboutMe',
            'curriculum-vitae': 'collapseCurriculum',
            'portfolio': 'collapseDesignPortfolio',
            'contact': 'collapseDesignContact'
        };
        
        const bsTarget = bsTargetMap[sectionId];
        console.log('Buscando acordeón con data-bs-target:', `[data-bs-target="#${bsTarget}"]`);
        
        if (bsTarget) {
            const accordionButton = document.querySelector(`[data-bs-target="#${bsTarget}"]`);
            if (accordionButton) {
                console.log('Botón del acordeón encontrado. Clases:', accordionButton.className);
                if (accordionButton.classList.contains('collapsed')) {
                    console.log('Haciendo click en acordeón cerrado');
                    accordionButton.click();
                } else {
                    console.log('Acordeón ya está abierto');
                }
            } else {
                console.log('Botón del acordeón NO encontrado');
                const allAccordionButtons = document.querySelectorAll('[data-bs-target]');
                console.log('Todos los botones de acordeón:', allAccordionButtons);
            }
        }
    }
  },
}
</script>

<style scoped>
.accordion-item-container{
  background-color: var(--black);
  position: relative;
  z-index: 10;
  padding: 6vh 0;
}
</style>